/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type OptIn = (typeof OptIn)[keyof typeof OptIn];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OptIn = {
  InfoArch: "infoArch",
} as const;
